export default "__VITE_ASSET__BhGxGpR4__"